import { createContext, useContext, useEffect, useState } from "react";

import { firebaseAuth } from "services/firebase";
import { logEvent } from "services/analytics";
import fetchManager from "utils/FetchManager";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isAuthLoading, setIsAuthLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const unsubscribe = firebaseAuth.onAuthStateChanged((user) => {
      setIsAuthLoading(false);
    });

    return unsubscribe;
  }, []);

  // Function to be called by custom event listeners when a user logs out
  const clearStateOnLogout = () => {
    // This function will dispatch a logout event that all contexts will listen for
    // to clear their state and abort pending requests
    console.log(
      "AuthContext: Triggering app-logout event to clear state and abort requests"
    );
    const logoutEvent = new CustomEvent("app-logout");
    window.dispatchEvent(logoutEvent);

    // Give fetchManager a chance to abort requests
    console.log(
      "Active fetch requests being aborted:",
      fetchManager.controllers.size
    );
  };

  const logOut = () => {
    // First clear all application state and abort pending requests
    clearStateOnLogout();

    // Then perform Firebase logout
    return firebaseAuth.signOut().then(
      () => {
        logEvent("logout");
      },
      (error) => {
        logEvent("user_logout_error");
        alert(
          "Error logging out. Please try again or contact us at support@xyloplan.com for support."
        );
      }
    );
  };

  useEffect(() => {
    const setUser = firebaseAuth.onAuthStateChanged((user) => {
      console.log("Logged in user", user);
      setCurrentUser(user);

      if (user) {
      }
    });

    return setUser;
  }, []);

  return (
    <AuthContext.Provider
      value={{
        isAuthLoading,
        currentUser,
        logOut,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
